import React, { ReactElement } from 'react';
import { FormHorizontal } from '~/components/form/layout';
import ZodFieldInput from '~/components/zod/ZodFieldInput';

export default function McmStagingForm(): ReactElement {
  return (
    <FormHorizontal name="photos" label="Number of Photos">
      <ZodFieldInput name="photos" type="number" />
    </FormHorizontal>
  );
}
